import { useNavigate } from 'react-router-dom';
import { useTeams } from '../../hooks/useWorkManagement';

interface TeamSelectorProps {
  teamId: string | null;
}

export function TeamSelector({ teamId }: TeamSelectorProps) {
  const { data: teams, isLoading } = useTeams();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <select disabled className="rounded-md bg-muted px-3 py-1.5 text-sm">
        <option>Loading teams...</option>
      </select>
    );
  }

  if (!teams || teams.length === 0) {
    return null;
  }

  return (
    <select
      value={teamId ?? ''}
      onChange={(e) => navigate(e.target.value ? `/work/teams/${e.target.value}` : '/work')}
      className="rounded-md bg-muted px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
      data-testid="team-selector"
    >
      <option value="">Select a team...</option>
      {teams.map((team) => (
        <option key={team.id} value={team.id}>
          {team.name}
        </option>
      ))}
    </select>
  );
}
